// extracted by mini-css-extract-plugin
export var copy_links_hover_light = "footer-module--copy_links_hover_light--c2de4";
export var dark_footer_bg = "footer-module--dark_footer_bg--b1a48";
export var footerLink = "footer-module--footerLink--fd56a";
export var grey_text = "footer-module--grey_text--1a02c";